<template>
    <v-col :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-row v-if="supplier && classifiersLoaded" no-gutters>
            <v-col class="grow">
                <v-row no-gutters class="mb-6">
                    <div class="project-heading">
                        <span class="headline font-weight-regular ml-3">
                            {{ supplier.name }}
                        </span>
                        <span v-if="canEditSupplier" class="ml-6">
                            <v-btn icon text color="grey" @click="editSupplierClick">
                                <v-icon>edit</v-icon>
                            </v-btn>
                        </span>
                    </div>
                </v-row>
                <v-row>
                    <v-col class="col-6">
                        <ClientProfileFieldGroupCard
                            v-for="(grouped_field, idx) in grouped_fields"
                            :key="grouped_field.group_name"
                            :grouped-field="grouped_field"
                            :show-system-fields="false"
                            :client="supplier"
                            :top-margin="idx > 0"
                            @edit_click="editSupplierClick"
                        />
                    </v-col>
                    <v-col class="col-6">
                        <NotesView :related-id="parseInt(supplierId)" related-type="supplier" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import SupplierModule from "../../store/modules/supplier";
import AppModule from "../../store/modules/app";
import CustomFieldsModule from "../../store/modules/custom_fields";
import { computed, ref, watch } from "@vue/composition-api";
import ClientProfileFieldGroupCard from "../../views/Client/ClientProfileFieldGroupCard";
import NotesView from "../Note/NotesView";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default {
    name: "SupplierView",
    components: {
        ClientProfileFieldGroupCard,
        NotesView
    },
    setup(props, ctx) {
        const { fetchSupplier } = SupplierModule();
        const { fetchClassifiers } = AppModule();
        const { getGroupedCustomFields } = CustomFieldsModule();

        const supplier = ref(null);
        const classifiersLoaded = ref(false);
        const grouped_fields = ref([]);

        const supplierId = computed(() => Number(ctx.root._route.params.id));
        const canEditSupplier = computed(() => {
            return true;
        });

        const loadData = () => {
            fetchSupplier(supplierId.value)
                .then(resp => {
                    supplier.value = resp;

                    fetchClassifiers({ types: ["custom_fields"], account_id: resp.account_id })
                        .then(() => {
                            grouped_fields.value = getGroupedCustomFields(supplier.value.account_id, "supplier.{0}".format(resp.type_id), supplier.value);
                            classifiersLoaded.value = true;
                        })
                        .catch(ex => errorDialog.showError(ex));
                })
                .catch(ex => errorDialog.showError(ex));
        }

        const editSupplierClick = () => {
            ctx.root._router.push({
                name: "supplier_edit",
                params: { id: supplierId.value },
            });
        }

        watch (supplierId, () => {
            loadData();
        }, { immediate: true });

        return {
            supplier,
            classifiersLoaded,
            canEditSupplier,
            grouped_fields,
            supplierId,
            editSupplierClick
        };
    }
}
</script>
